/**
 * Event ID of an edition (brief section 7.1): SERIES-YEAR, accents removed,
 * uppercase, anything other than letters and digits as hyphens.
 * Example: "Ecomondo Italy", 2027 gives ECOMONDO-ITALY-2027.
 */
export function eventCode(series: string, year: number): string {
  const base = series
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return `${base}-${year}`;
}
